import type { FC } from 'react';
import { Contract } from '../types';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

interface Props {
  contract: Contract;
  onBack: () => void;
  onComplete: (contract: Contract) => void;
  onDelete: (id: string) => void;
}

const ContractDetail: FC<Props> = ({ contract, onBack, onComplete, onDelete }) => {
  const getStatusText = (status: Contract['status']) => {
    const statuses = {
      draft: 'Черновик',
      active: 'Активен',
      completed: 'Выполнен',
      overdue: 'Просрочен',
      cancelled: 'Отменён'
    };
    return statuses[status];
  };

  const isOverdue = new Date(contract.deadline) < new Date() && contract.status === 'active';

  return (
    <div className="contract-detail">
      <button className="btn-back" onClick={onBack}>← Назад</button>
      
      <div className="detail-header">
        <h2>{contract.title}</h2>
        <span className={`status-badge status-${isOverdue ? 'overdue' : contract.status}`}>
          {isOverdue ? 'Просрочен' : getStatusText(contract.status)}
        </span>
      </div>

      <div className="detail-section">
        <h3>📝 Описание</h3>
        <p>{contract.description}</p>
      </div>

      <div className="detail-grid">
        <div className="detail-item">
          <span className="label">📅 Создан</span>
          <span className="value">
            {format(new Date(contract.createdAt), 'dd MMM yyyy', { locale: ru })}
          </span>
        </div>
        
        <div className="detail-item">
          <span className="label">⏰ Дедлайн</span>
          <span className={`value ${isOverdue ? 'overdue' : ''}`}>
            {format(new Date(contract.deadline), 'dd MMM yyyy', { locale: ru })}
          </span>
        </div>

        <div className="detail-item">
          <span className="label">👤 Создатель</span>
          <span className="value">
            {contract.creator === 'alex' ? 'Alex' : 'Cody'}
          </span>
        </div>

        {contract.reward && (
          <div className="detail-item reward">
            <span className="label">🏆 Награда</span>
            <span className="value">{contract.reward}</span>
          </div>
        )}

        {contract.penalty && (
          <div className="detail-item penalty">
            <span className="label">⚠️ Штраф</span>
            <span className="value">{contract.penalty}</span>
          </div>
        )}

        {contract.completedAt && (
          <div className="detail-item">
            <span className="label">✅ Выполнен</span>
            <span className="value">
              {format(new Date(contract.completedAt), 'dd MMM yyyy', { locale: ru })}
            </span>
          </div>
        )}

        {contract.notes && (
          <div className="detail-item full-width">
            <span className="label">📝 Заметки</span>
            <span className="value">{contract.notes}</span>
          </div>
        )}
      </div>

      <div className="detail-actions">
        {contract.status === 'active' && (
          <button 
            className="btn btn-success"
            onClick={() => {
              if (confirm('Отметить как выполненный?')) {
                onComplete(contract);
              }
            }}
          >
            ✅ Отметить выполненным
          </button>
        )}
        
        <button 
          className="btn btn-danger"
          onClick={() => {
            if (confirm('Удалить контракт?')) {
              onDelete(contract.id);
            }
          }}
        >
          🗑️ Удалить
        </button>
      </div>
    </div>
  );
};

export default ContractDetail;